import { newE2EPage } from "@stencil/core/testing";

describe("rendering", () => {
    it("should render a component", async () => {
        const page = await newE2EPage();
        await page.setContent(`<uic-segmented-control></uic-segmented-control>`);
        const el = await page.find("uic-segmented-control");
        expect(el).toHaveClass("hydrated");
    });

    it("should match to snapshot", async () => {
        const page = await newE2EPage();
        await page.setContent(`<uic-segmented-control>
            <uic-button value="item1" selected>Item 1</uic-button>
            <uic-button value="item2">Item 2</uic-button>
        </uic-segmented-control>`);
        const el = await page.find("uic-segmented-control");
        expect(el).toMatchSnapshot();
    });
});
